import { useContext, useEffect, useState } from "react";

import PanelContext from "../../context/PanelContext";
import { useQuery } from "@tanstack/react-query";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
import Container from "@mui/material/Container";
import CustomButton from "../CustomButton";
import CustomTextField from "../CustomTextField";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { getPreviousMonths } from "../../utils/dateUtils";
import { getDateFilter } from "../../services/newAPI";
import DashboardContext from "../../context/DashboardContext";

export default function TitleAndFilter(props) {
  const {
    filterTextInput,
    handleFilterInputChange,
    submitFilter,
    panelTitle,
    handleResetFilterButton,
    cpfError,
    download,
    downloadTxt,
  } = useContext(PanelContext);
  const { nodeToken } = useContext(DashboardContext)

  const { data: filterData } = useQuery(["filterData"], () => getDateFilter(nodeToken));

  return (
    <Container
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Typography color="primary" component="h1" fontWeight={700} variant="h4">
        {panelTitle}
      </Typography>

      <form onSubmit={submitFilter}>
        <CustomTextField
          color="primary"
          label="Ano"
          name="filterTypeInput"
          onChange={({ target: { value } }) => props?.setYear(value)}
          select
          size="small"
          sx={{ width: "120px", marginLeft: "10px" }}
          value={props.year}
          variant="outlined"
        >
          {filterData?.years.map((item) => {
            return <MenuItem
                      key={item}
                      value={item}
                    >
                      {item}
                    </MenuItem>;
          })}
        </CustomTextField>
        <CustomTextField
          color="primary"
          label="Mês"
          name="filterTypeInput"
          onChange={({ target: { value } }) => props?.setMonth(value)}
          select
          size="small"
          sx={{ width: "120px", marginLeft: "10px" }}
          value={props.month}
          variant="outlined"
        >
          {filterData?.months.map((item) => {
            return <MenuItem
                      key={item}
                      value={item}
                    >
                      {item}
                    </MenuItem>;
          })}
        </CustomTextField>

        <CustomTextField
          autoComplete="off"
          color="primary"
          error={cpfError}
          helperText={cpfError && "O CPF precisa ter 11 números"}
          label="Filtrar por CPF"
          name="textInput"
          onChange={handleFilterInputChange}
          size="small"
          sx={{ ml: 1, width: "180px" }}
          type="text"
          value={filterTextInput}
          variant="outlined"
        />

        <CustomButton
          color="primary"
          endIcon={<FilterAltIcon />}
          sx={{ mx: 1 }}
          type="submit"
          variant="contained"
        >
          Filtrar
        </CustomButton>
        <Tooltip title="Descartar filtro">
          <CustomButton
            color="error"
            onClick={() => {
              handleResetFilterButton();
              props.setFilterState(false);
            }}
            sx={{ maxWidth: "40px", minWidth: "40px" }}
            type="button"
            variant="contained"
          >
            <ClearIcon />
          </CustomButton>
        </Tooltip>

        <Tooltip title="Download txt">
          <CustomButton
            color="info"
            onClick={downloadTxt}
            sx={{ marginLeft: "8px", maxWidth: "40px", minWidth: "40px" }}
            type="button"
            variant="contained"
          >
            <FontDownloadIcon />
          </CustomButton>
        </Tooltip>
      </form>
    </Container>
  );
}
